//import env from '@/environment';
import { AppError } from '@/models/app-error';

export class PageMessage {
    
    constructor() {
        this.exists = false;
        this.message = '';
    }

    reset() {
        this.exists = false;
        this.message = '';        
    }    
    
    set(message) {
        this.exists = true;
        this.message = message;        
    }

    setError(error) {
        /*if (env.debug) {
            console.error(error);
        }*/

        if (error instanceof AppError) {
            this.set(error.message);
            return;
        } 
        
        if (typeof error == 'string' || error instanceof String) {
            this.set(error);
            return;
        }

        this.set('Something went wrong...');
    }
}